export enum ClaimDomainStep {
  EnterDomain,
  EnterEmail,
  AuthGoogle,
  AuthSaml,
  AuthLdap,
  CheckEmail,
  Done,
  Error,
}
export type TestUser = {
  username: string;
  password: string;
};
